export var SEND_NOTIFICATION = 'SEND_NOTIFICATION';